// Replay deny rules take precedence over host allow rules, including custom API hosts.
export const deviceNetworkDetailDenyUrls = [/\/employee\/devices\/(?:current|disassociate)(?:[/?#]|$)/];
